import { render, staticRenderFns } from "./preStartupReviewDetail.vue?vue&type=template&id=5f870e62"
import script from "./preStartupReviewDetail.vue?vue&type=script&lang=js"
export * from "./preStartupReviewDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f870e62')) {
      api.createRecord('5f870e62', component.options)
    } else {
      api.reload('5f870e62', component.options)
    }
    module.hot.accept("./preStartupReviewDetail.vue?vue&type=template&id=5f870e62", function () {
      api.rerender('5f870e62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/psr/preStartupReviewDetail.vue"
export default component.exports